"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPort = void 0;
const isInt_1 = require("./isInt");
function isPort(str) {
    return (0, isInt_1.isInt)(str, {
        min: 0,
        max: 65535,
    });
}
exports.isPort = isPort;
